// extracted by mini-css-extract-plugin
export default {"collapse":"I5tpy85ZBBBykcM1CCbq"};